import React from 'react';
import factory from 'components/Icons/factory';

export const Twitter = factory(
  'Twitter',
  <g>
    <path d="M41.7 112.8c45.3 0 70.1-37.5 70.1-70.1 0-1.1 0-2.1-.1-3.2 4.8-3.5 9-7.8 12.3-12.7-4.5 2-9.3 3.3-14.1 3.9 5.1-3.1 9-7.9 10.8-13.6-4.8 2.9-10.1 4.9-15.6 6-9.3-9.9-24.9-10.4-34.8-1.1-6.4 6-9.1 15-7.1 23.5-19.8-1-38.2-10.3-50.7-25.7C5.8 31 9.2 45.4 20 52.6c-3.9-.1-7.8-1.2-11.2-3.1v.3c0 11.7 8.3 21.8 19.8 24.1-3.6 1-7.4 1.1-11.1.4 3.2 10 12.5 16.9 23 17.1C31.8 98.3 21 102 9.9 102c-2 0-3.9-.1-5.9-.4 11.3 7.3 24.4 11.2 37.7 11.2" />
  </g>
);

export default Twitter;
